import * as React from 'react';

const HistorySvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15.172} height={15.172}>
    <path
      data-name="Path 1"
      d="M7.586 1.517a6.069 6.069 0 1 0 6.069 6.069 6.069 6.069 0 0 0-6.069-6.069ZM0 7.586a7.586 7.586 0 1 1 7.586 7.586A7.586 7.586 0 0 1 0 7.586Zm7.586-4.552a.759.759 0 0 1 .759.759v3.479l2.054 2.054a.759.759 0 0 1-1.073 1.073L7.05 8.123a.758.758 0 0 1-.222-.536V3.793a.759.759 0 0 1 .758-.759Z"
      fill="#fff"
    />
  </svg>
);

export default HistorySvg;
